module.exports = __webpack_public_path__ + "static/assets/24609c50afb138ad00a7027f23265783.png";